/**
 * Possible URLs:
 *
 * Base
 * ----
 * cz.oriflame.com
 * cz-uat.oriflame.com
 * cz-stg.oriflame.com
 * cz-live.ori-test.com
 * cz-stg.ori-test.com
 * cz-uat.ori-test.com
 * cz.online.ori
 * cz-stg.online.ori
 * cz-uat.online.ori
 *
 * Test
 * ----
 * oriflame.cz
 * www.oriflame.cz
 * stg.oriflame.vn
 * uat.oriflame.vn
 *
 * PR Deployments
 * --------------
 * 12345-cz.appshell-pr-we.oriflame.
 *
 * Localhost
 * ---------
 * cz-local.oriflame.com
 * local.oriflame.cz
 *
 */

import { ENVIRONMENT_CODES } from '../constants';
const BASE_HOST_REGEX = /(\/\/:|^)[a-z]{2}(-(?<environment>(uat|stg|live)))?\.(oriflame\.com|ori-test\.com|online\.ori)/i;
const NATIONAL_DOMAIN_HOST_REGEX = /(\/\/:|^)((www|(?<environment>(uat|stg)))\.)?(oriflame|ori-test)\.[a-z]{2}/i;

// const PR_DEPLOY_HOST_REGEX = /(\/\/:|^)[a-z]{2}-\d{6,8}\.appshell-pr-\w{2,4}\.oriflame\.com/i;

// const DEVELOPMENT_HOST_REGEX = /(\/\/:|^)[a-z]{2}-?local\.oriflame\.com/i;

/**
 * Gets a environment from host
 */
export const getEnvironmentFromHost = host => {
  const getEnvironment = regex => regex.exec(host)?.groups?.environment;
  const environment = getEnvironment(BASE_HOST_REGEX) ?? getEnvironment(NATIONAL_DOMAIN_HOST_REGEX);
  return environment ? environment : ENVIRONMENT_CODES.LIVE;
};
//# sourceMappingURL=getEnvironmentFromHost.js.map